import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { LayoutDashboardIcon, UsersIcon, WalletIcon, StarIcon, CrownIcon, TagIcon, BellIcon, BarChart3Icon, ShieldIcon, ScrollTextIcon, LogOutIcon, ChevronLeftIcon, MenuIcon, ExternalLinkIcon } from 'lucide-react';
import { useAuth } from '../../lib/AuthContext';
import { Badge } from '../ui/Badge';
const NAV_ITEMS = [{
  to: '/admin/tong-quan',
  label: 'Tổng Quan',
  icon: LayoutDashboardIcon
}, {
  to: '/admin/khach-hang',
  label: 'Khách Hàng',
  icon: UsersIcon
}, {
  to: '/admin/vi-dien-tu',
  label: 'Ví Điện Tử',
  icon: WalletIcon
}, {
  to: '/admin/diem',
  label: 'Điểm Thưởng',
  icon: StarIcon
}, {
  to: '/admin/hang',
  label: 'Hạng Thành Viên',
  icon: CrownIcon
}, {
  to: '/admin/khuyen-mai',
  label: 'Khuyến Mãi',
  icon: TagIcon
}, {
  to: '/admin/thong-bao',
  label: 'Thông Báo',
  icon: BellIcon
}, {
  to: '/admin/bao-cao',
  label: 'Báo Cáo',
  icon: BarChart3Icon
}, {
  to: '/admin/nhan-vien',
  label: 'Nhân Viên',
  icon: ShieldIcon
}, {
  to: '/admin/nhat-ky',
  label: 'Nhật Ký',
  icon: ScrollTextIcon
}];
export function AdminSidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const {
    currentStaff,
    adminLogout
  } = useAuth();
  const isActive = (path: string) => location.pathname.startsWith(path);
  const roleLabels: Record<string, string> = {
    owner: 'Chủ sở hữu',
    manager: 'Quản lý',
    cashier: 'Thu ngân',
    marketing: 'Marketing'
  };
  const SidebarContent = () => <div className="flex flex-col h-full" data-id="element-59">
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-5 border-b border-[#2A2A2A]" data-id="element-60">
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#C8A84E] to-[#B8963E] flex items-center justify-center flex-shrink-0" data-id="element-61">
          <span className="text-[#0D0D0D] font-bold text-xs" data-id="element-62">MHP</span>
        </div>
        {!collapsed && <div data-id="element-63">
            <span className="text-white font-semibold text-sm block" data-id="element-64">
              Mỹ Hòa Phát
            </span>
            <span className="text-[10px] text-[#C8A84E] uppercase tracking-wider" data-id="element-65">
              Admin Panel
            </span>
          </div>}
      </div>

      {/* Nav */}
      <nav className="flex-1 py-3 px-2 space-y-0.5 overflow-y-auto" data-id="element-66">
        {NAV_ITEMS.map(item => {
        const Icon = item.icon;
        const active = isActive(item.to);
        return <Link key={item.to} to={item.to} onClick={() => setMobileOpen(false)} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 ${active ? 'bg-[#C8A84E]/10 text-[#C8A84E]' : 'text-[#B0B0B0] hover:bg-[#1A1A1A] hover:text-white'}`} title={collapsed ? item.label : undefined} data-id="element-67">
              <Icon className="w-4.5 h-4.5 flex-shrink-0" style={{
            width: 18,
            height: 18
          }} data-id="element-68" />
              {!collapsed && <span data-id="element-69">{item.label}</span>}
              {active && !collapsed && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#C8A84E]" data-id="element-70" />}
            </Link>;
      })}
      </nav>

      {/* User */}
      <div className="border-t border-[#2A2A2A] p-3" data-id="element-71">
        {currentStaff && !collapsed && <div className="flex items-center gap-3 px-2 mb-3" data-id="element-72">
            <div className="w-8 h-8 rounded-full bg-[#2A2A2A] flex items-center justify-center flex-shrink-0" data-id="element-73">
              <ShieldIcon className="w-4 h-4 text-[#C8A84E]" data-id="element-74" />
            </div>
            <div className="min-w-0" data-id="element-75">
              <p className="text-sm font-medium text-white truncate" data-id="element-76">
                {currentStaff.name}
              </p>
              <Badge variant="gold" size="sm" data-id="element-77">
                {roleLabels[currentStaff.role]}
              </Badge>
            </div>
          </div>}
        <Link to="/" className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-[#B0B0B0] hover:text-[#C8A84E] hover:bg-[#C8A84E]/5 transition-colors w-full mb-1" title={collapsed ? 'Về Trang Khách Hàng' : undefined} data-id="element-78">
          <ExternalLinkIcon className="w-4 h-4" data-id="element-79" />
          {!collapsed && <span data-id="element-80">Về Trang Khách Hàng</span>}
        </Link>
        <button onClick={() => {
        adminLogout();
        window.location.href = '/';
      }} className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-[#666666] hover:text-[#EF4444] hover:bg-[#EF4444]/5 transition-colors w-full" data-id="element-81">
          <LogOutIcon className="w-4 h-4" data-id="element-82" />
          {!collapsed && <span data-id="element-83">Đăng Xuất</span>}
        </button>
      </div>
    </div>;
  return <>
      {/* Mobile toggle */}
      <button onClick={() => setMobileOpen(true)} className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg text-[#B0B0B0]" data-id="element-84">
        <MenuIcon className="w-5 h-5" data-id="element-85" />
      </button>

      {/* Mobile overlay */}
      <AnimatePresence data-id="element-86">
        {mobileOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="lg:hidden fixed inset-0 z-40 bg-black/60" onClick={() => setMobileOpen(false)} data-id="element-87" />}
      </AnimatePresence>

      {/* Mobile sidebar */}
      <AnimatePresence data-id="element-88">
        {mobileOpen && <motion.aside initial={{
        x: -280
      }} animate={{
        x: 0
      }} exit={{
        x: -280
      }} transition={{
        type: 'spring',
        bounce: 0,
        duration: 0.3
      }} className="lg:hidden fixed left-0 top-0 bottom-0 w-[260px] bg-[#0D0D0D] border-r border-[#2A2A2A] z-50" data-id="element-89">
            <SidebarContent data-id="element-90" />
          </motion.aside>}
      </AnimatePresence>

      {/* Desktop sidebar */}
      <aside className={`hidden lg:flex flex-col fixed left-0 top-0 bottom-0 bg-[#0D0D0D] border-r border-[#2A2A2A] z-30 transition-all duration-300 ${collapsed ? 'w-[68px]' : 'w-[240px]'}`} data-id="element-91">
        <SidebarContent data-id="element-92" />
        <button onClick={() => setCollapsed(!collapsed)} className="absolute -right-3 top-20 w-6 h-6 bg-[#1A1A1A] border border-[#2A2A2A] rounded-full flex items-center justify-center text-[#666666] hover:text-white transition-colors" data-id="element-93">
          <ChevronLeftIcon className={`w-3.5 h-3.5 transition-transform ${collapsed ? 'rotate-180' : ''}`} data-id="element-94" />
        </button>
      </aside>
    </>;
}